import { render, staticRenderFns } from "./TreatmentBreakDialogForm.vue?vue&type=template&id=47574e7c&scoped=true"
import script from "./TreatmentBreakDialogForm.vue?vue&type=script&lang=js"
export * from "./TreatmentBreakDialogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47574e7c",
  null
  
)

export default component.exports